import styled from 'styled-components';

// styles
export const Wrapper = styled.div`
    background: #201E67;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: auto;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 40px 120px;
    gap: 20px;
	position: relative;
    @media (max-width: 1200px) {
        padding: 45px 30px;
    }
    @media (max-width: 1100px) {
        padding-bottom: 100px;
    }
    @media (max-width: 900px) {
        padding: 30px 20px;
        gap: 40px;
        padding-bottom: 110px;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        @media (max-width: 900px) {
            flex-direction: column;
        }
    }
    .title-section {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
        width: 100px;
        ${p => p.lang !== 'fa' && `
            width: 130px;
        `}
        @media (max-width: 900px) {
            width: 100%;
        }
        .title {
            color: white;
            font-size: 13px;
            font-weight: 400;
            @media (max-width: 900px) {
                font-size: 12px;
            }
        }
    }
    h3 {
        width: 75%;
        @media (max-width: 1000px) {
            width: 100%;
        }
    }
    .logo {
        @media (max-width: 900px) {
            margin-bottom: -20px;
        }
    }
    .sign {
        border-radius: 10px;
    }
    .sign-item {
        width: 100px;
        height: 124px;
    }
    .text {
        color: white;
        font-size: 14px;
        @media (max-width: 900px) {
            font-size: 13px;
        }
    }
    .weight-500 {
        font-weight: 500;
        @media (max-width: 900px) {
            text-align: center;
        }
    }
    .column {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        @media (max-width: 900px) {
            width: 100%;
            gap: 20px;
        }
    }
    .flex-end {
        justify-content: flex-end;
        align-items: flex-end;
    }
    .address {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        gap: 10px;
        @media (max-width: 1000px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 0;
        }
    }
    .signs {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        height: 124px;
        @media (max-width: 900px) {
            width: 100%;
            margin-top: 40px;
            margin-bottom: -20px;
            justify-content: center;
        }
    }
    .socials {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 15px;
        .follow-us {
            margin-left: 50px;
            font-size: 11px;
            @media (max-width: 900px) {
                margin-left: 0px;
            }
        }
    }
    .copyright-section {
       p {
        margin-top: -10px
       }
    }
`;
